import * as angular from 'angular';
import { IRequestService } from '../request.service';
import { ObjectUser, UserGroups } from '../../models';

export interface IUserGroupsService {
    getAll(force?: boolean): angular.IPromise<UserGroups[]>;
    update(updated: UserGroups): angular.IPromise<UserGroups>;
    getUsage(force?: boolean): angular.IPromise<ObjectUser[]>;
    deleteOne(deleted: UserGroups): angular.IPromise<UserGroups>;
}

export class UserGroupsService implements IUserGroupsService {
    static serviceId = 'userGroupsService';
    static $inject = ['requestService'];

    private _controllerUrl = 'userGroups';

    constructor(private _requestService: IRequestService) {
    }

    getAll(force?: boolean): angular.IPromise<UserGroups[]> {
        const url = `${this._controllerUrl}`;
        if (force) {
            this._requestService.cleanCacheAtV1(url);
        }
        return this._requestService.getAtV1(url, undefined, true);
    }

    update(updated: UserGroups): angular.IPromise<UserGroups> {
        return this._requestService.postAtV1<UserGroups>(`${this._controllerUrl}/addOrUpdate`, updated, undefined, true)
            .then(data => {
                this._requestService.cleanCacheAtV1(this._controllerUrl);
                return data;
            });
    }

    getUsage(force?: boolean): angular.IPromise<ObjectUser[]> {
        if (force) {
            this._requestService.cleanCacheAtV1(`${this._controllerUrl}/usage`);
        }
        return this._requestService.getAtV1<ObjectUser[]>(`${this._controllerUrl}/usage`, undefined, true);
    }

    deleteOne(deleted: UserGroups): angular.IPromise<UserGroups> {
        return this._requestService.postAtV1<UserGroups>(`${this._controllerUrl}/delete`, deleted, undefined, true)
            .then(data => {
                this._requestService.cleanCacheAtV1(this._controllerUrl);
                return data;
            });
    }
}